module.exports = __webpack_public_path__ + "static/media/loading.42ea4ab8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/loading.gif
// module id = 686
// module chunks = 0